/**
 * Mali tablolar — isteğe bağlı `href` (PDF vb.). İndeks, i18n `financialStatements.periods` sırasıyla eşleşir.
 * @typedef {{ href?: string }} FinancialStatementPeriodMeta
 */

/** @type {FinancialStatementPeriodMeta[]} */
export const FINANCIAL_STATEMENT_PERIOD_META = [];
